import { useEffect } from "react";
import { useLocation } from "wouter";
import { useToast } from "@/hooks/use-toast";

// Feature flag for legacy proof-of-posting page
const ENABLE_PROOF_OF_POSTING_LEGACY = false;

export default function LegacyProofOfPostingRedirect() {
  const [, setLocation] = useLocation();
  const { toast } = useToast();

  useEffect(() => {
    const logData = {
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      referrer: document.referrer,
      url: window.location.href
    };

    // Log access to legacy route for monitoring
    console.log('🚨 Legacy proof-of-posting route accessed:', logData);

    // Send to server for logging
    fetch(`/api/legacy-proof-of-posting-access?${new URLSearchParams(logData)}`, {
      method: 'GET',
      credentials: 'omit'
    }).catch(err => console.error('Failed to log legacy route access:', err));

    if (ENABLE_PROOF_OF_POSTING_LEGACY) {
      // If legacy is enabled, redirect to TaskDetail (current behavior)
      console.log('Legacy proof-of-posting enabled - redirecting to TaskDetail');
      // This would redirect to TaskDetail component
    } else {
      // Redirect to the new proof-of-posting-v2 page
      console.log('Legacy proof-of-posting disabled - redirecting to v2');
      
      toast({
        title: "Page Moved",
        description: "Proof of Posting has been updated. Redirecting to the new version.",
        duration: 5000,
      });
      
      // Redirect to the new version
      setLocation("/proof-of-posting-v2");
    }
  }, [setLocation, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <h2 className="mt-4 text-lg font-semibold text-gray-900">
            Redirecting to Updated Page
          </h2>
          <p className="mt-2 text-gray-600">
            The Proof of Posting page has been improved. You're being redirected to the new version.
          </p>
        </div>
      </div>
    </div>
  );
}